import { FC, JSX, useMemo, useState } from 'react';
import { FieldError } from 'react-hook-form';

import Input from '@semcore/ui/input';

import EnterURLsModal from './EnterURLsModal';

interface IPublishURLsProps {
  value: string;
  onChange: (...event: unknown[]) => void;
  error?: FieldError;
}

export const PublishURLs: FC<IPublishURLsProps> = ({
  value = '',
  onChange,
  error,
}): JSX.Element => {
  const [showEnterURLsModal, setShowEnterURLsModal] = useState(false);
  const onSave = (newUrls: string) => {
    const normalized = newUrls
      .split('\n')
      .map((url) => url.trim())
      .filter((url) => url.length)
      .join(',');

    setShowEnterURLsModal(false);
    onChange(normalized);
  };
  const urls = useMemo(
    () =>
      value
        .split(',')
        .map((url) => url.trim())
        .filter((url) => url.length),
    [value]
  );
  const inputValue = urls.length
    ? `Selected: ${urls.length} link${urls.length > 1 ? 's' : ''}`
    : '';

  return (
    <>
      <Input size="m" state={error ? 'invalid' : 'normal'}>
        <Input.Value
          className="rounded-lg bg-white"
          placeholder="URL"
          value={inputValue}
          readOnly
          onClick={() => setShowEnterURLsModal(true)}
        />
      </Input>
      <EnterURLsModal
        urls={urls.join('\n')}
        onClose={() => setShowEnterURLsModal(false)}
        onSave={onSave}
        visible={showEnterURLsModal}
      />
      {error && (
        <div className="text-sm font-light text-red">{error?.message}</div>
      )}
    </>
  );
};

export default PublishURLs;
